import { borrarCustomCookies, createCookieByMinutes } from '../Helpers/Cookies';
import { METERING_ARC_EXPIRATION, METERING_ARC_EXPIRATION_ERROR } from '../Config/Cookies'
import UCL from '../Helpers/UserClientLibs';

const meteringConfig = {
    "metering": "metering_arc",
    "serviceDown": "MeteringCookieServiceDown"
}

const obtenerCookieSuscriptor = async () => {
    borrarCustomCookies(Object.values(meteringConfig))

    return fetch(`${process.env.REACT_APP_APIAUTHORIZE}user`, {
        method: 'GET',
        headers: {
            'X-Token': await UCL.GetIdTokenValidatedAsync(),
            'Authorization': await UCL.BuildBearerAccessTokenAsync()
        }
    })
        .then(response => {
            if (response.status === 200) {
                return response.text();
            }
            if (response.status === 500) {
                createCookieByMinutes(meteringConfig["serviceDown"], true, METERING_ARC_EXPIRATION_ERROR);
                createCookieByMinutes('metering_arc_ERROR', "response.status: 500 - " + ((response && response.statusText) ? response.statusText : ""), METERING_ARC_EXPIRATION_ERROR);
            }
            return null;
        })
        .then(data => {
            if (data) {
                createCookieByMinutes(meteringConfig["metering"], data, METERING_ARC_EXPIRATION);
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            createCookieByMinutes(meteringConfig["serviceDown"], true, METERING_ARC_EXPIRATION_ERROR);
            createCookieByMinutes('metering_arc_ERROR', error, METERING_ARC_EXPIRATION_ERROR);
        });
}

export default { obtenerCookieSuscriptor }